import { useContext } from "react";
import { GlobalContext } from "../../../context";
import CourseBlackboardPage from "../../../page/Dashboard/CourseBlackboardPage";
import StudentCoursePage from "./StudentCoursePage";

/** /dashboard/course/:uuid — students get the new week-based course page; staff keep the old one. */
export default function CoursePageSwitch() {
  const { authState: { data } } = useContext(GlobalContext);
  const staff = data?.user?.is_admin || data?.user?.is_instructor;

  return staff ? <CourseBlackboardPage /> : <StudentCoursePage />;
}
